import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import _ from "lodash";
import { Card, Collapse } from "react-bootstrap";
import { bikeEnumToNumStatuses } from "data/bike-numeric-statuses";
import filterTypes from "data/filter-types";
import tagTypes from "data/tag-types";
import findFilterValue from "helpers/find-filter-value";
import searchOperationGenerator from "helpers/search-operation-generator";
import FilterItem from "views/lib/components/filter/filter-item";
import FilterHeader from "views/lib/components/filter/filter-header";
import { getBikeStatuses, getBikeFilters } from "actions/bike/actions";
import {
  getNoPagination
} from "actions/tag/actions";

class BikeFilers extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
      filters: {}
    };

    this.handleSearch = this.handleSearch.bind(this);
    this.handleReset = this.handleReset.bind(this);
    this.handleChangeFilter = this.handleChangeFilter.bind(this);

    this.props.getBikeStatuses();
    this.props.getBikeFilters();
    this.props.getTags([{
      fieldName: "type",
      fieldValue: tagTypes.bike,
      searchOperation: filterTypes.EQUALS.value
    }]);
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.totalCount !== this.props.totalCount) {
      return true;
    } else if (nextState.isOpen !== this.state.isOpen) {
      return true;
    } else if (!_.isEqual(nextState.filters, this.state.filters)) {
      return true;
    } else if (!_.isEqual(nextProps.activeFilters, this.props.activeFilters)) {
      return true;
    } else if (!_.isEqual(nextProps.serverFilters, this.props.serverFilters)) {
      return true;
    }
    return false;
  }

  handleSearch = () => {
    const { filters } = this.state;
    const filtersToArray = [];
    Object.keys(filters)
      .forEach(name => {
        if (Object.keys(filters[name]).length) {
          filtersToArray.push(filters[name]);
        }
      });
    this.props.handleSearch(filtersToArray);
  };

  handleReset = () => {
    this.setState({
      filters: {}
    }, this.props.handleReset);
  };

  handleChangeFilter = (name, valueObject) => {
    const { filters } = this.state;
    filters[name] = valueObject;
    this.setState({
      filters
    });
  };

  render() {
    const {
      activeFilters,
      totalCount,
      serverFilters,
      bikeStatuses,
      tags
    } = this.props;

    const { isOpen } = this.state;

    return (
      <Card className="w-100 mb-2 rounded-0">
        <FilterHeader
          title="Bikes"
          totalCount={totalCount}
          isOpen={isOpen}
          onToggle={(status) => this.setState({ isOpen: status })}
        />
        <Card.Body className="p-0">
          <Collapse in={isOpen} className="p-3" timeout={0}>
            <div className="row">
              <div className="col-12 col-md-3 mb-3">
                <FilterItem
                  name="id"
                  placeholder="ID"
                  filterType="text"
                  defaultValue=""
                  onChange={this.handleChangeFilter}
                  searchOperation={searchOperationGenerator(serverFilters.id)}
                  value={findFilterValue("id", activeFilters)}
                />
              </div>
              <div className="col-12 col-md-3 mb-3">
                <FilterItem
                  name="qr"
                  placeholder="QR Code"
                  filterType="text"
                  defaultValue=""
                  onChange={this.handleChangeFilter}
                  searchOperation={searchOperationGenerator(serverFilters.qr)}
                  value={findFilterValue("qr", activeFilters)}
                />
              </div>
              <div className="col-12 col-md-3 mb-3">
                <FilterItem
                  name="condition.speed"
                  placeholder="Speed"
                  filterType="number"
                  defaultValue=""
                  onChange={(name, valueObject) => {
                    if (typeof valueObject === "object" && Object.keys(valueObject).length) {
                      this.handleChangeFilter(name, {
                        ...valueObject,
                        fieldValue: parseFloat(valueObject.fieldValue)
                      });
                    } else {
                      this.handleChangeFilter(name, {});
                    }
                  }}
                  searchOperation={searchOperationGenerator(serverFilters["condition.speed"])}
                  value={findFilterValue("condition.speed", activeFilters)}
                />
              </div>
              <div className="col-12 col-md-3 mb-3">
                <FilterItem
                  name="condition.charging"
                  placeholder="On Battery"
                  filterType="select"
                  filterTypeOptions={[
                    {
                      label: "Yes",
                      value: false
                    },
                    {
                      label: "No",
                      value: true
                    },
                  ]}
                  onChange={this.handleChangeFilter}
                  searchOperation={searchOperationGenerator(serverFilters["condition.charging"])}
                  value={findFilterValue("condition.charging", activeFilters)}
                />
              </div>
              <div className="col-12 col-md-3 mb-3">
                <FilterItem
                  name="condition.voltage"
                  placeholder="Voltage"
                  filterType="number"
                  onChange={(name, valueObject) => {
                    if (typeof valueObject === "object" && Object.keys(valueObject).length) {
                      this.handleChangeFilter(name, {
                        ...valueObject,
                        fieldValue: parseFloat(valueObject.fieldValue)
                      });
                    } else {
                      this.handleChangeFilter(name, {});
                    }
                  }}
                  searchOperation={searchOperationGenerator(serverFilters["condition.voltage"])}
                  value={findFilterValue("condition.voltage", activeFilters)}
                />
              </div>
              <div className="col-12 col-md-3 mb-3">
                <FilterItem
                  name="mac"
                  placeholder="MAC - example: C4:A8:28:07:EA:43"
                  filterType="text"
                  onChange={this.handleChangeFilter}
                  searchOperation={searchOperationGenerator(serverFilters.mac)}
                  value={findFilterValue("mac", activeFilters)}
                />
              </div>
              <div className="col-12 col-md-3 mb-3">
                <FilterItem
                  name="condition.gps"
                  placeholder="On GPS"
                  filterType="select"
                  filterTypeOptions={[
                    {
                      label: "Yes",
                      value: true
                    },
                    {
                      label: "No",
                      value: false
                    },
                  ]}
                  onChange={this.handleChangeFilter}
                  searchOperation={searchOperationGenerator(serverFilters["condition.gps"])}
                  value={findFilterValue("condition.gps", activeFilters)}
                />
              </div>
              <div className="col-12 col-md-3 mb-3">
                <FilterItem
                  name="sim.phone"
                  placeholder="SIM - example: +37495012345"
                  filterType="text"
                  defaultValue=""
                  onChange={this.handleChangeFilter}
                  searchOperation={searchOperationGenerator(serverFilters["sim.phone"])}
                  value={findFilterValue("sim.phone", activeFilters)}
                />
              </div>
              <div className="col-12 col-md-3 mb-3">
                <FilterItem
                  name="condition.closed"
                  placeholder="Locked"
                  filterType="select"
                  filterTypeOptions={[
                    {
                      label: "Yes",
                      value: true
                    },
                    {
                      label: "No",
                      value: false
                    },
                  ]}
                  onChange={this.handleChangeFilter}
                  searchOperation={searchOperationGenerator(serverFilters["condition.closed"])}
                  value={findFilterValue("condition.closed", activeFilters)}
                />
              </div>
              <div className="col-12 col-md-3 mb-3">
                <FilterItem
                  name="status"
                  placeholder="Status"
                  filterType="select_multiple"
                  filterTypeOptions={bikeStatuses.map(value => ({
                    label: value,
                    value: bikeEnumToNumStatuses[value]
                  }))}
                  onChange={this.handleChangeFilter}
                  searchOperation={searchOperationGenerator(serverFilters.status)}
                  defaultFilterType={filterTypes.IN.value}
                  value={findFilterValue("status", activeFilters)}
                />
              </div>
              <div className="col-12 col-md-3 mb-3">
                <FilterItem
                  name="updated_at"
                  placeholder="Updated"
                  filterType="date"
                  onChange={this.handleChangeFilter}
                  searchOperation={searchOperationGenerator(serverFilters.updated_at)}
                  value={findFilterValue("updated_at", activeFilters)}
                />
              </div>
              <div className="col-12 col-md-3 mb-3">
                <FilterItem
                  name="lastBookUser"
                  placeholder="Last Booked By"
                  filterType="text"
                  onChange={this.handleChangeFilter}
                  searchOperation={searchOperationGenerator(serverFilters["lastBookUser"], [filterTypes.EQUALS.value])}
                  value={findFilterValue("lastBookUser", activeFilters)}
                />
              </div>
              <div className="col-12 col-md-3 mb-3">
                <FilterItem
                  name="lastRideUser"
                  placeholder="Last Rider"
                  filterType="text"
                  onChange={this.handleChangeFilter}
                  searchOperation={searchOperationGenerator(serverFilters["lastRideUser"], [filterTypes.EQUALS.value])}
                  value={findFilterValue("lastRideUser", activeFilters)}
                />
              </div>

              <div className="col-12 col-md-3 mb-2">
                <FilterItem
                  name="tags"
                  placeholder="Tags"
                  filterType="select_multiple"
                  filterTypeOptions={tags.map(value => ({
                    label: value.name,
                    value: value.name
                  }))}
                  onChange={this.handleChangeFilter}
                  searchOperation={searchOperationGenerator(null, [filterTypes.IN.value])}
                  value={findFilterValue("tags", activeFilters)}
                />
              </div>
              <div className="col-12 col-md-3 mb-3 offset-md-3 offset-md-0">
                <div className="d-flex justify-content-between justify-content-md-end">
                  <button
                    className="btn btn-warning btn-sm"
                    onClick={this.handleReset}
                  >
                    Reset
                  </button>
                  <button
                    className="btn btn-success btn-sm ml-2"
                    onClick={this.handleSearch}
                  >
                    Load
                  </button>
                </div>
              </div>
            </div>
          </Collapse>
        </Card.Body>
      </Card>
    );
  }
}

BikeFilers.propTypes = {
  handleSearch: PropTypes.func.isRequired,
  handleReset: PropTypes.func.isRequired,
  totalCount: PropTypes.number.isRequired,
};

const mapStateToProps = state => ({
  serverFilters: state.bike.serverFilters,
  bikeStatuses: state.bike.statuses,
  tags: state.tag.tagListNoPagination,
});

const mapStateToDispatch = dispatch => ({
  getBikeFilters: bindActionCreators(getBikeFilters, dispatch),
  getBikeStatuses: bindActionCreators(getBikeStatuses, dispatch),

  getTags: bindActionCreators(getNoPagination, dispatch),
});

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(BikeFilers);



// WEBPACK FOOTER //
// ./src/views/pages/bikes/filters.js